import React, { FC } from 'react';

import { FeatureType } from '@/api/config/types';
import Image from '@/components/core/Image';

import './styles.scss';

export interface FeatureProps {
  feature: FeatureType;
}

const Feature: FC<FeatureProps> = ({ feature }) => {
  return (
    <div className="featureBlock">
      <div className="featureItemImg">
        <div
          className="featureLogoItem games"
          style={{
            backgroundColor: feature.color,
          }}
        >
          <Image src={feature.logo} width={300} height={300} alt="feature" />
        </div>
      </div>
      <div className="featureItem">
        <h3 className="featureBlTitleTxt">{feature.name}</h3>
        <div className="featureBlTxt" dangerouslySetInnerHTML={{ __html: feature.description }} />
      </div>
    </div>
  );
};

export default Feature;
